// Migrated
// Translated
<template>
  <div class="print-hidden px-4 md:px-0">
    <h4
      class="mb-4 mt-12"
      data-i18n="otherSimilarTrips"
    >
      {{ title || $t('otherSimilarTrips') }}
    </h4>
    <LazyTrips
      class="px-0"
      :trips="suggested"
      :wide-modulus="11"
      :high-modulus="6"
    />
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    suggested: {
      type: Array,
      required: true,
    },

    title: {
      type: String,
      default: null,
    },
  },
})
</script>
